import { FC } from "react";

// Контурные иконки 24×24 для плиток условий (stroke = currentColor).
const PATHS = {
  coins: [
    "M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3z",
    "M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6",
    "M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6",
  ],
  trophy: [
    "M7 4h10v5a5 5 0 0 1-10 0z",
    "M7 6H4v1a3 3 0 0 0 3 3",
    "M17 6h3v1a3 3 0 0 1-3 3",
    "M12 14v4M8 21h8M9 18h6",
  ],
  people: [
    "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    "M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1",
    "M16 3.2a4 4 0 0 1 0 7.6M18.5 14.4A6 6 0 0 1 22 20v1",
  ],
  chart: ["M5 20v-6M10 20V10M15 20V7M20 20V4"],
  link: [
    "M10 14a4.5 4.5 0 0 0 6.4 0l3.2-3.2a4.5 4.5 0 0 0-6.4-6.4L12 5.6",
    "M14 10a4.5 4.5 0 0 0-6.4 0l-3.2 3.2a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2",
  ],
  award: [
    "M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12z",
    "M8.5 13.9 7 22l5-3 5 3-1.5-8.1",
  ],
  layers: ["M12 3 2 8l10 5 10-5z", "M2 13l10 5 10-5", "M2 17.5l10 5 10-5"],
  calendar: [
    "M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
    "M4 10h16M8 2v4M16 2v4",
    "M8 14h.01M12 14h.01M16 14h.01M8 17h.01M12 17h.01",
  ],
  clipboard: [
    "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2",
    "M9 2h6v4H9z",
    "M8 11h.01M11 11h5M8 15h.01M11 15h5",
  ],
} as const;

export type ConditionIconName = keyof typeof PATHS;

interface Props {
  name: ConditionIconName;
  size?: number;
}

export const ConditionIcon: FC<Props> = ({ name, size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {PATHS[name].map((d) => (
      <path key={d} d={d} />
    ))}
  </svg>
);
